/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProvinciaRes } from '../../models/provincia-res';

export interface LuoghiControllerFindManyProvince$Params {
  /**
   * Codice Regione
   */
  codiceRegione: string;

  /**
   * Filter by active status (0 = inactive, 1 = active)
   */
  flagAttivo?: number;
}

export function luoghiControllerFindManyProvince(
  http: HttpClient,
  rootUrl: string,
  params: LuoghiControllerFindManyProvince$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<ProvinciaRes>>> {
  const rb = new RequestBuilder(
    rootUrl,
    luoghiControllerFindManyProvince.PATH,
    'get',
  );
  if (params) {
    rb.query('codiceRegione', params.codiceRegione, {});
    rb.query('flagAttivo', params.flagAttivo, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ProvinciaRes>>;
      }),
    );
}

luoghiControllerFindManyProvince.PATH = '/luoghi/province';
